<template>
  <div>    
    <div class="page-title">
      <h5>Курсы</h5>
    </div>

    <Loader v-if="loading" />

    <div v-else>
      <div v-for="course of courses" v-bind:key="course.id">
        <div class="section">
          <a class="indigo-text text-lighten-1">Курс</a>
          <h5 class="indigo-text text-darken-4">{{course.name}}</h5>
          <p>
            {{course.description}}
            <br />
            <br />
            <a
              v-on:click.prevent="setCourse(course.id)"
              class="waves-effect waves-light btn-flat btn-small indigo lighten-5"
            >
              <i class="material-icons right">arrow_forward</i>
              Выбрать
            </a>
          </p>

          <div class="divider"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "courses",
  data: () => ({
    loading: true
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    courses() {
      return this.$store.getters.courses;
    },
    course() {
      return this.$store.getters.course;
    }
  },
  async mounted() {
    if (this.$store.getters.courses.length === 0) {
      await this.$store.dispatch("getCourses", {
        idUser: this.user.id,
        id: "0"
      });
    }
    this.loading = false;
  },
  methods: {
    async setCourse(id) {
      if (this.course.id != id) {
        this.$store.commit("clearCourseState");
        this.$store.commit("clearModeState");
        this.$store.commit("clearRegimeState");
        const course = this.courses.find(element => {
          return element.id == id;
        });
        this.$store.commit("setCourse", course);
        await this.$store.dispatch("getCourseVideos", {
          idUser: this.user.id,
          id: this.course.id
        });
        await this.$store.dispatch("getCourseModes", {
          idUser: this.user.id,
          id: this.course.id
        });

      }
      this.$router.push("/course/course");
    }
  },
  components: {}
};
</script>
